// extracted by mini-css-extract-plugin
export default {"appFrame":"AppFrame_appFrame__U0TOj","scrollWrapper":"AppFrame_scrollWrapper__ikOrx","centerWrapper":"AppFrame_centerWrapper__0n-j3","content":"AppFrame_content__aCE25"};